import { Endpoints } from "../../../constants/endpoints";
import { TJobRaw } from "./types";
import client from "../../client";

export const getJob = (jobId: string | number) => async () => {
  const { data } = await client.get<TJobRaw>(Endpoints.getJob(jobId));
  return data;
};
